import { load } from "recaptcha-v3";

const SITE_KEY = document.querySelector('meta[name="recaptcha-site-key"]')?.content;

const initRecaptcha = async () => {
    const forms = document.querySelectorAll("form[data-recaptcha-action]");
    if (!SITE_KEY || forms.length === 0) return;

    const recaptcha = await load(SITE_KEY);

    forms.forEach((form) => {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();

            // 二重送信防止
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton?.disabled) return;
            if (submitButton) submitButton.disabled = true;

            try {
                const token = await recaptcha.execute(form.dataset.recaptchaAction);
                form.querySelector('input[name="g-recaptcha-response"]').value = token;
                form.submit();
            } catch (err) {
                // recaptcha API への通信失敗時はトークン未設定のままサーバへ送信し、
                // サーバ側のバリデーションエラーで既存のエラー表示エリアに出す
                console.error("reCAPTCHA failed:", err);
                form.submit();
            }
        });
    });
};

export default initRecaptcha;
